import { render, staticRenderFns } from "./SupportPalestine.vue?vue&type=template&id=f6e0890a&scoped=true&"
import script from "./SupportPalestine.vue?vue&type=script&lang=js&"
export * from "./SupportPalestine.vue?vue&type=script&lang=js&"
import style0 from "./SupportPalestine.vue?vue&type=style&index=0&id=f6e0890a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e0890a",
  null
  
)

export default component.exports